import { RootState } from 'model/store'
import { createSelector } from '@reduxjs/toolkit'
import _ from 'lodash'

export const getItems = (state: RootState) => state.items
export const getTours = (state: RootState) => state.tours
export const getSlots = (state: RootState) => state.slots
export const getUser = (state: RootState) => state.user
// export const getSettings = (state: RootState) => state.settings
export const getTourModels = (state: RootState) => state.tourModels
export const getRequestsDesign = (state: RootState) => state.requestsDesign
export const getRoomTypes = (state: RootState) => state.roomTypes
export const getTemplates = (state: RootState) => state.templates

export const getAppLoaded = createSelector(
  [getItems, getSlots, getUser],
  (items, slots, user) => {
    const lst = [items, slots, user]
    const doneAmount = _.reduce(
      lst,
      (res, elt) => {
        return _.isNil(elt) ? res : res + 1
      },
      0
    )
    return doneAmount === _.size(lst) ? null : (doneAmount / _.size(lst)) * 100
  }
)
